var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-table-simple",
    {
      staticClass: "mt-2",
      staticStyle: { "max-height": "65vh", "font-size": "12px" },
      attrs: { bordered: "", responsive: "", "sticky-header": "" },
    },
    [
      _c("colgroup", [
        _c("col", { staticStyle: { width: "120px" } }),
        _c("col", { staticStyle: { width: "120px" } }),
        _c("col", { staticStyle: { width: "100px" } }),
        _c("col", { staticStyle: { width: "100px" } }),
        _c("col", { staticStyle: { width: "100px" } }),
        _c("col", { staticStyle: { width: "100px" } }),
        _c("col", { staticStyle: { width: "100px" } }),
        _c("col", { staticStyle: { width: "100px" } }),
      ]),
      _c(
        "b-thead",
        { attrs: { "head-variant": "light" } },
        [
          _c(
            "b-tr",
            [
              _c(
                "b-th",
                {
                  staticStyle: { "text-align": "center" },
                  attrs: { rowspan: "2" },
                },
                [_vm._v("지역")]
              ),
              _c(
                "b-th",
                {
                  staticStyle: { "text-align": "center" },
                  attrs: { rowspan: "2" },
                },
                [_vm._v("진료과")]
              ),
              _c(
                "b-th",
                {
                  staticStyle: { "text-align": "center" },
                  attrs: { colspan: "3" },
                },
                [_vm._v("라이브 DI 노출 수")]
              ),
              _c(
                "b-th",
                {
                  staticStyle: { "text-align": "center" },
                  attrs: { colspan: "3" },
                },
                [_vm._v("라이브 DI 클릭 수")]
              ),
            ],
            1
          ),
          _c(
            "b-tr",
            [
              _c(
                "b-th",
                { staticStyle: { "text-align": "center", top: "40px" } },
                [_vm._v("전체")]
              ),
              _c(
                "b-th",
                { staticStyle: { "text-align": "center", top: "40px" } },
                [_vm._v("의사 수")]
              ),
              _c(
                "b-th",
                { staticStyle: { "text-align": "center", top: "40px" } },
                [_vm._v("의원 수")]
              ),
              _c(
                "b-th",
                { staticStyle: { "text-align": "center", top: "40px" } },
                [_vm._v("전체")]
              ),
              _c(
                "b-th",
                { staticStyle: { "text-align": "center", top: "40px" } },
                [_vm._v("의사 수")]
              ),
              _c(
                "b-th",
                { staticStyle: { "text-align": "center", top: "40px" } },
                [_vm._v("의원 수")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-tbody",
        [
          !_vm.gridVisible
            ? [
                _c("tr", [
                  _c(
                    "td",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { colspan: "8" },
                    },
                    [
                      _vm._v(
                        " 라이브 DI 업데이트로 2025-08-28 이전 데이터는 제공되지 않습니다. "
                      ),
                    ]
                  ),
                ]),
              ]
            : _vm.data.length > 0
            ? [
                _vm._l(_vm.data, function (region, rIdx) {
                  return [
                    _vm._l(region.liveDiDepts, function (dept, dIdx) {
                      return [
                        _c(
                          "b-tr",
                          {
                            key: "cumulative-" + rIdx + "-" + dIdx,
                            style:
                              region.regionName === "(미분류제외) 전체 합"
                                ? "background-color: rgba(127, 127, 255, 0.1);"
                                : "",
                          },
                          [
                            _c(
                              "b-td",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: dIdx === 0,
                                    expression: "dIdx === 0",
                                  },
                                ],
                                staticStyle: { "text-align": "center" },
                                attrs: {
                                  rowspan: region.liveDiDepts.length + 1,
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(/*지역*/ region.regionName) + " "
                                ),
                              ]
                            ),
                            _c(
                              "b-td",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      /*진료과*/ dept.medicalDepartmentName
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "b-td",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("$numberFormatter")(
                                        /*전체*/ dept.liveDiStatDetail
                                          .totalShowCount
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "b-td",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("$numberFormatter")(
                                        /*의사수*/ dept.liveDiStatDetail
                                          .doctorShowCount
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "b-td",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("$numberFormatter")(
                                        /*의원수*/ dept.liveDiStatDetail
                                          .hcpShowCount
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "b-td",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("$numberFormatter")(
                                        /*전체*/ dept.liveDiStatDetail
                                          .totalClickCount
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "b-td",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("$numberFormatter")(
                                        /*의사수*/ dept.liveDiStatDetail
                                          .doctorClickCount
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "b-td",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("$numberFormatter")(
                                        /*의원수*/ dept.liveDiStatDetail
                                          .hcpClickCount
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    }),
                    _c(
                      "b-tr",
                      {
                        key: "cumulative-subtotal-" + rIdx,
                        staticClass: "h6 font-weight-bolder",
                        staticStyle: {
                          "background-color": "rgba(127, 255, 127, 0.1)",
                        },
                      },
                      [
                        _vm.useSubTotal
                          ? _c(
                              "b-td",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      /*지역별 합계*/ region.regionName ===
                                        "(미분류제외) 전체 합"
                                        ? "전체 합계"
                                        : "지역별 소계"
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "b-td",
                          { staticStyle: { "text-align": "center" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("$numberFormatter")(
                                    /*합계 노출 전체*/ region.subTotal
                                      .totalShowCount
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "b-td",
                          { staticStyle: { "text-align": "center" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("$numberFormatter")(
                                    /*합계 노출 의사수*/ region.subTotal
                                      .doctorShowCount
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "b-td",
                          { staticStyle: { "text-align": "center" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("$numberFormatter")(
                                    /*합계 노출 의원수*/ region.subTotal
                                      .hcpShowCount
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "b-td",
                          { staticStyle: { "text-align": "center" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("$numberFormatter")(
                                    /*합계 클릭 전체*/ region.subTotal
                                      .totalClickCount
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "b-td",
                          { staticStyle: { "text-align": "center" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("$numberFormatter")(
                                    /*합계 클릭 의사수*/ region.subTotal
                                      .doctorClickCount
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "b-td",
                          { staticStyle: { "text-align": "center" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("$numberFormatter")(
                                    /*합계 클릭 의원수*/ region.subTotal
                                      .hcpClickCount
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                }),
              ]
            : [
                _c("tr", [
                  _c(
                    "td",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { colspan: "8" },
                    },
                    [_vm._v(" 라이브 DI를 선택해 주세요. ")]
                  ),
                ]),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }